import { render, staticRenderFns } from "./highLowEventTable.vue?vue&type=template&id=70bcf44e&scoped=true"
import script from "./highLowEventTable.vue?vue&type=script&lang=js"
export * from "./highLowEventTable.vue?vue&type=script&lang=js"
import style0 from "./highLowEventTable.vue?vue&type=style&index=0&id=70bcf44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcf44e",
  null
  
)

export default component.exports